import { motion } from "framer-motion";
import { ETAPES, IMAGES } from "../../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Etapes = () => (
  <section id="methode" data-testid="methode-section" className="relative py-24 sm:py-32 overflow-hidden">
    <div className="glow-blob absolute top-1/3 -left-40 w-[480px] h-[480px] rounded-full bg-purple-200/40" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        label="Notre méthode"
        title="Votre parcours en 3 étapes"
        description="Un chemin simple, balisé et rassurant : de l'évaluation de départ jusqu'au jour de l'examen, vous savez toujours où vous en êtes."
      />

      <div className="mt-16 space-y-16 sm:space-y-24">
        {ETAPES.map((step, i) => (
          <div
            key={step.num}
            className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
          >
            <Reveal>
              <motion.div whileHover={{ scale: 0.985 }} transition={{ duration: 0.3 }} className="relative">
                <div className="glow-blob absolute -inset-4 rounded-[2.5rem] bg-violet-300/30" />
                <img
                  src={IMAGES[step.image]}
                  alt={step.alt}
                  loading="lazy"
                  data-testid={`etape-image-${step.num}`}
                  className="relative rounded-[1.8rem] w-full aspect-[16/11] object-cover shadow-[0_24px_70px_rgb(0,0,0,0.12)]"
                />
                <span className="absolute -top-5 -left-3 sm:-left-5 font-heading font-black text-6xl sm:text-7xl text-white drop-shadow-[0_4px_16px_rgb(109,40,217,0.55)] bg-violet-700 rounded-2xl px-4 py-1 rotate-[-4deg]">
                  {step.num}
                </span>
              </motion.div>
            </Reveal>
            <div>
              <Reveal delay={0.1}>
                <span className="uppercase tracking-[0.2em] text-xs font-bold text-violet-700">Étape {step.num}</span>
              </Reveal>
              <Reveal delay={0.16}>
                <h3 className="font-heading font-extrabold tracking-tight text-slate-900 text-2xl sm:text-3xl mt-3">
                  {step.title}
                </h3>
              </Reveal>
              <Reveal delay={0.22}>
                <p className="text-slate-600 leading-relaxed text-sm sm:text-base mt-4 max-w-lg">{step.text}</p>
              </Reveal>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
